var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcDislike = function SvgIcDislike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 2.1984C14.9781 2.19279 14.559 2.13118 14.1535 2.0152L11.2463 1.1848C10.8178 1.06233 10.3743 1.00014 9.92867 1H6.02067C4.83072 0.999985 3.68319 1.44197 2.80069 2.2402C1.9182 3.03844 1.36366 4.13602 1.24467 5.32L1.00467 9.4C0.962223 10.2328 1.21022 11.0546 1.7063 11.7249C2.20239 12.3952 2.91579 12.8724 3.72467 13.0752L4.88867 13.3296C5.14868 13.3941 5.37965 13.5437 5.54478 13.7546C5.70991 13.9656 5.79971 14.2257 5.79987 14.4936V17.2C5.79987 17.6774 5.98951 18.1352 6.32708 18.4728C6.66464 18.8104 7.12248 19 7.59987 19C8.07726 19 8.53509 18.8104 8.87266 18.4728C9.21023 18.1352 9.39987 17.6774 9.39987 17.2V15.9568C9.39987 14.3655 10.032 12.8394 11.1572 11.7142C12.2824 10.5889 13.8086 9.9568 15.3999 9.9568V2.1984Z",
    stroke: "#1A202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4004 1H19.0004V11.8H15.4004V1Z",
    stroke: "#1A202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcDislike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_dislike.748851bf.svg";
export { ForwardRef as ReactComponent };